import { Component } from 'vue-property-decorator';
import { METRICS_CUSTOM_COLUMN, METRICS_CUSTOM_EVENT, METRICS_CUSTOM_EVENT_REVENUE, METRICS_CUSTOM_EVENT_HIDDEN_REVENUE } from '@/services/constants/report';
import { mixins } from 'vue-class-component';
import PostbacksMetricsMixin from '@/views/reports/pickers/base/postbacks/metrics';
import LivesVisitsMetricsMixin from '@/views/reports/pickers/base/live-visits/metrics';
import LiveClicksMetricsMixin from '@/views/reports/pickers/base/live-clicks/metrics';
import ErrorsMetricsMixin from '@/views/reports/pickers/base/errors/metrics';
import ConversionsMetricsMixin from '@/views/reports/pickers/base/conversions/metrics';
import BaseMetricsMixin from '@/views/reports/pickers/base/base-metrics-mixin';
import _ from 'lodash';


@Component
export default class ReportMetricsMixin extends mixins(
  PostbacksMetricsMixin,
  LiveClicksMetricsMixin,
  LivesVisitsMetricsMixin,
  ErrorsMetricsMixin,
  mixins(
    ConversionsMetricsMixin,
    BaseMetricsMixin
  ),
) {
  reportMetricsName(key:string) {
    if(key.startsWith(METRICS_CUSTOM_EVENT)){
      const pureKey = key.replace(METRICS_CUSTOM_EVENT,'');
      return (this.$store.state.table.customEvents[pureKey]?.name || key);
    }
    
    if(key.startsWith(METRICS_CUSTOM_EVENT_REVENUE)){
      const pureKey = key.replace(METRICS_CUSTOM_EVENT_REVENUE,'');
      return `${(this.$store.state.table.customEvents[pureKey]?.name || key)} (${this.t('revenue')})`  || key;
    }
    
    if(key.startsWith(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE)){
      const pureKey = key.replace(METRICS_CUSTOM_EVENT_HIDDEN_REVENUE,'');
      return `${(this.$store.state.table.customEvents[pureKey]?.name || key)} (${this.t('Hidden Revenue')})`  || key;
    }

    if (key.startsWith(METRICS_CUSTOM_COLUMN)) {
      return this.$store.getters.getCustomColumns[key.slice(METRICS_CUSTOM_COLUMN.length)]?.name
    }

    const name = `metric.${key}`;
    return this.t(name);
  }

  getCustomMetrics(routeName: string) {
    switch(routeName) {
      case 'app.conversions':
        return this.conversionsMetrics;
      case 'app.postbacks':
        return this.postbacksMetrics;
      case 'app.errors':
        return this.errorsMetrics;
      case 'app.live-clicks':
        return this.liveClicksMetrics;
      case 'app.live-visits':
        return this.liveVisitsMetrics;
      default:
        return this.baseMetrics;
    }
  }

  createColumn(value,options?) {
    return {
      text: this.reportMetricsName(value),
      value: value,
      ...(options ? options : {})
    }
  }

  existingCustomMetrics(routeName) {
    return (this.getCustomMetrics(routeName) as any).avaliable_metrics.map(this.createColumn);
  }

  get additionalMainColumns() {
    const { dimensions } = this.$store.state.reportColumns

    return this.$store.getters.tableQueryForCurrentTab.treeLevels
      ?.filter((item)=>!!item)
      ?.map((item: string) => this.createColumn(dimensions[item].mainColumn, { disabled:true })) || [];
  }

  mainMetrics(type, routeName) {
    const { dimensions, metrics } = this.$store.state.reportColumns
    const { isHideFilters } = this.$store.state.table;

    const { additionalColumns = [], mainColumn } = dimensions[type] || {};

    const mainColumnValue = mainColumn ? this.createColumn(mainColumn, { disabled:true }) : null;

    let columns = [...additionalColumns, ...metrics].map(this.createColumn)

    if(isHideFilters) {
      const exclude = this.getCustomMetrics(routeName).report_exclude[type]
      if(exclude) {
        columns = columns.filter(({ value }) => !exclude.includes(value));
      }
    }

    return mainColumnValue ? [mainColumnValue, ...this.additionalMainColumns, ...columns] : [...this.additionalMainColumns, ...columns]
  }

  getMetricsList(routeName, type)  {
    switch(routeName) {
      case 'app.conversions':
      case 'app.postbacks':
      case 'app.errors':
      case 'app.live-clicks':
      case 'app.live-visits':
        return this.existingCustomMetrics(routeName);

      default:
        return this.mainMetrics(type, routeName);
    }
  }
}
